import { put, takeEvery } from "redux-saga/effects";

import { loading } from "layouts/AppLayout/modules";
import { getApi } from "../../../sagas";
import { UPLOAD_BANNER, UploadBannerAction, uploadBannerFailure, uploadBannerSuccess } from "../actions";

export function* uploadBanner(action: UploadBannerAction) {
    const { payload } = action;
    const { appId, blob, contentType } = payload;

    const api = getApi(payload);

    try {
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const result = yield api.uploadBanner(appId, blob, contentType);
        yield put(uploadBannerSuccess(result.app));
    } catch (e) {
        yield put(uploadBannerFailure(e));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchUploadBanner() {
    yield takeEvery(UPLOAD_BANNER, uploadBanner);
}
